// * Replace with query
export const radioSections = [
  {
    label: 'I’m currently insured on another car',
    value: 'S',
  },
  {
    label: 'I’m insured as a named driver on my spouse’s car',
    value: 'N',
  },
  {
    label: 'I’ve been insured as part of a company car scheme',
    value: 'C',
  },
  {
    label: 'I’ve been insured as part of the Motability scheme',
    value: 'M',
  },
  {
    label: 'I’ve been insured as part of a car club (e.g. Zipcar)',
    value: 'CC',
  },
]

export const radioSectionExtra = { label: 'None of these apply', value: 'X' }
